import { RemoveDamagedPartsQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/removeDamagedParts/removeDamagedPartsQuery.type';
import { removeDamagedPartsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/removeDamagedParts/removeDamagedPartsQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const useRemoveDamagedPartsQueryOptions = () => {
  return useMutation({
    mutationKey: ['removeDamagedParts'],
    mutationFn: (params: RemoveDamagedPartsQueryParamsType) =>
      removeDamagedPartsFunction(params),
  });
};
